import { FC } from "react";
import remarkFrontmatter from "remark-frontmatter";

import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import remarkGitbookBlocks from "shared/ui/markdown/remark-custom-plugins/gitbook";
import { MarkdownComponentGitbook } from "shared/ui/markdown/components/gitbook";
import { MarkdownPreview } from "shared/ui/markdown/preview";

type GitbookMarkdownPreviewPropsI = PropsWithClassNameI & {
  children: null | string | undefined;
  path?: string;
};

/**
 * GitBook-specific markdown preview component that automatically handles:
 * - Relative links (converts to absolute GitBook URLs)
 * - GitBook shortcodes ({% hint %}, {% embed %}, etc.)
 * - YAML frontmatter
 */
export const GitbookMarkdownPreview: FC<GitbookMarkdownPreviewPropsI> = ({
  children,
  className,
  path,
}) => {
  // used to convert relative links to absolute URLs in the markdown
  // ex. "../../some-page" will be converted to "https://docs.glencoco.com/some-page"
  const gitbookBaseUrl = `https://docs.glencoco.com/${path || ""}`;

  return (
    <MarkdownPreview
      className={className}
      hrefBaseUrl={gitbookBaseUrl}
      remarkPlugins={[
        remarkFrontmatter, // Parse YAML frontmatter from GitBook markdown
        remarkGitbookBlocks, // Process GitBook shortcodes ({% hint %}, {% embed %})
      ]}
      components={{
        "gitbook-hint": MarkdownComponentGitbook,
        "gitbook-embed": MarkdownComponentGitbook,
      }}
    >
      {children}
    </MarkdownPreview>
  );
};
